var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.44971 27.6654L6.22315 21.1911C4.84918 18.8077 4.29992 16.0376 4.66052 13.3103C5.02112 10.583 6.27144 8.05086 8.21762 6.10647C10.1638 4.16209 12.6971 2.9141 15.4247 2.556C18.1524 2.19791 20.9219 2.74972 23.3041 4.12587C25.6862 5.50202 27.5477 7.62564 28.6001 10.1674C29.6524 12.7093 29.8368 15.5272 29.1246 18.1845C28.4123 20.8418 26.8434 23.1898 24.6608 24.8646C22.4783 26.5394 19.8043 27.4473 17.0532 27.4477H17.0478C14.9609 27.4467 12.9075 26.9227 11.0753 25.9235L4.44971 27.6654Z",
    fill: "url(#paint0_linear_13_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 28.1172L5.83658 21.411C4.41377 18.9422 3.84519 16.0729 4.21899 13.2481C4.59279 10.4233 5.88809 7.80068 7.90406 5.78692C9.92003 3.77316 12.544 2.48074 15.3693 2.11004C18.1945 1.73934 21.0631 2.31107 23.5304 3.73659C25.9976 5.1621 27.9256 7.36177 29.0155 9.99454C30.1054 12.6273 30.2963 15.5461 29.5585 18.2984C28.8208 21.0507 27.1957 23.4827 24.9351 25.2174C22.6745 26.9521 19.9048 27.8925 17.0553 27.8929H17.0499C14.8884 27.8927 12.7614 27.3511 10.863 26.3176L4 28.1172ZM11.1852 23.9737L11.5782 24.2078C13.2366 25.1893 15.1283 25.7071 17.0553 25.7069C19.4412 25.7069 21.7595 24.914 23.6457 23.4529C25.5319 21.9917 26.879 19.9452 27.4754 17.635C28.0717 15.3248 27.8834 12.8819 26.94 10.6904C25.9966 8.49892 24.3517 6.68306 22.2639 5.52829C20.176 4.37352 17.7636 3.94534 15.4059 4.31106C13.0482 4.67677 10.8788 5.81565 9.23889 7.54865C7.59897 9.28164 6.58145 11.5105 6.34631 13.8848C6.11118 16.2591 6.67174 18.6442 7.93989 20.6652L8.19573 21.0724L7.10706 25.0417L11.1852 23.9737Z",
    fill: "url(#paint1_linear_13_626)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8188 9.53036C13.5771 8.99147 13.3223 8.98058 13.0915 8.97079C12.9032 8.96316 12.6866 8.96317 12.471 8.96317C12.3071 8.96764 12.146 9.00592 11.9976 9.07561C11.8492 9.1453 11.7169 9.2449 11.6088 9.36815C11.3127 9.69475 10.4766 10.4742 10.4766 12.0659C10.4766 13.6575 11.636 15.1958 11.8015 15.4113C11.967 15.6269 14.0398 18.9974 17.3276 20.294C20.0601 21.3718 20.6164 21.1573 21.2097 21.104C21.8031 21.0506 23.1236 20.3212 23.3925 19.5657C23.6614 18.8102 23.6625 18.1635 23.5819 18.0274C23.5014 17.8913 23.2847 17.8097 22.9614 17.6507C22.6381 17.4918 21.0475 16.7058 20.7514 16.598C20.4553 16.4902 20.2386 16.4369 20.0231 16.7602C19.8075 17.0835 19.1881 17.8119 18.9987 18.0274C18.8092 18.243 18.622 18.2713 18.2986 18.1091C17.9753 17.9469 16.9324 17.6061 15.6967 16.5033C14.9876 15.8488 14.3797 15.0927 13.8928 14.2595C13.7045 13.9329 13.8732 13.7609 14.0354 13.5998C14.1802 13.455 14.362 13.222 14.5199 13.0326C14.6548 12.8681 14.7648 12.6847 14.8465 12.4883C14.8896 12.399 14.9097 12.3003 14.905 12.2012C14.9002 12.1021 14.8708 12.0058 14.8193 11.9211C14.7409 11.7698 14.1073 10.1694 13.8188 9.53036Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_626",
    x: 0,
    y: 0,
    width: 34,
    height: 34.1172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_626",
    x1: 17.001,
    y1: 27.6654,
    x2: 17.001,
    y2: 2.45075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_626",
    x1: 17.0009,
    y1: 28.1172,
    x2: 17.0009,
    y2: 1.99893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppIcon);
export default __webpack_public_path__ + "static/media/WhatsAppIcon.63cc4e05e6f68c89c3c2cb1d79cffc9f.svg";
export { ForwardRef as ReactComponent };